<template>
  <div>
    <app-spinner v-if="!page_loaded"/>
    <template v-else>
      <app-cells>
        <app-button @click.native="onShowModal">Create order</app-button>
        <app-input
          v-model="filter_search"
          @input.native="onOrdersSearch"
          class="input--300"
          type="search"
          placeholder="Search"
          name="search"
        />
        <app-input
          v-model="filter_item_id"
          @input.native="onOrdersSearch"
          class="input--300"
          type="search"
          placeholder="Search by id"
          name="search_id"
        />
        <app-select
          @search="onSupplierSearch"
          @input="onFilterItems"
          v-model="filter_supplier"
          :options="supplier_options"
          label="trade_name"
          placeholder="Supplier"
          class="select--300"
        />
      </app-cells>
      <app-cells><h2 class="title">Drafts</h2></app-cells>
      <v-client-table
        :data="table_draft.items"
        :columns="table_draft.columns"
        :options="table_draft.options"
        class="table-default"
      >
        <template #h__id>
          <div class="table-default__left">ID</div>
        </template>
        <template #h__supplier>
          <div class="table-default__left">Supplier</div>
        </template>
        <template #id="{ row }">
          <div class="table-default__left">
            <router-link :to="{name: 'storage-product-storage-orders-detail', params: {id: row.id }}"
                         class="table-default__link-border">
              Order - {{ row.id }}
            </router-link>
          </div>
        </template>
        <template #date="{ row }">
          {{ dateFormat(row.date) }}
        </template>
        <template #supplier="{ row }">
          <router-link
            v-if="is_general_manager || is_product_storage_manager || is_product_storage_supervisor"
            :to="{name: 'supplier-detail', params: {id: row.supplier.id }}"
            class="table-default__link-border"
          >
            {{ row.supplier.trade_name }}
          </router-link>
          <div v-else class="table-default__left">{{ row.supplier.trade_name }}</div>
        </template>
        <template #estimated="{ row }">{{ amountFormat(row.estimated) }} TSh</template>
      </v-client-table>
      <template v-if="table_ready.items.length > 0">
        <app-cells><h2 class="title">Ready</h2></app-cells>
        <v-client-table
          :data="table_ready.items"
          :columns="table_ready.columns"
          :options="table_ready.options"
          class="table-default"
        >
          <template #h__id>
            <div class="table-default__left">ID</div>
          </template>
          <template #h__supplier>
            <div class="table-default__left">Supplier</div>
          </template>
          <template #id="{ row }">
            <div class="table-default__left">
              <router-link :to="{name: 'storage-product-storage-orders-detail', params: {id: row.id }}"
                           class="table-default__link-border">
                Order - {{ row.id }}
              </router-link>
            </div>
          </template>
          <template #date="{ row }">
            {{ dateFormat(row.date) }}
          </template>
          <template #supplier="{ row }">
            <router-link
              v-if="is_general_manager || is_product_storage_manager || is_product_storage_supervisor"
              :to="{name: 'supplier-detail', params: {id: row.supplier.id }}"
              class="table-default__link-border"
            >
              {{ row.supplier.trade_name }}
            </router-link>
            <div v-else class="table-default__left">{{ row.supplier.trade_name }}</div>
          </template>
          <template #estimated="{ row }">{{ amountFormat(row.estimated) }} TSh</template>
        </v-client-table>
      </template>
      <app-cells><h2 class="title">In process</h2></app-cells>
      <v-client-table
        :data="table_process.items"
        :columns="table_process.columns"
        :options="table_process.options"
        class="table-default"
      >
        <template #h__id>
          <div class="table-default__left">ID</div>
        </template>
        <template #h__supplier>
          <div class="table-default__left">Supplier</div>
        </template>
        <template #id="{ row }">
          <div class="table-default__left">
            <router-link :to="{name: 'storage-product-storage-orders-detail', params: {id: row.id }}"
                         class="table-default__link-border">
              Order - {{ row.id }}
            </router-link>
          </div>
        </template>
        <template #date="{ row }">
          {{ dateFormat(row.date) }}
        </template>
        <template #supplier="{ row }">
          <router-link
            v-if="is_general_manager || is_product_storage_manager || is_product_storage_supervisor"
            :to="{name: 'supplier-detail', params: {id: row.supplier.id }}"
            class="table-default__link-border"
          >
            {{ row.supplier.trade_name }}
          </router-link>
          <div v-else class="table-default__left">{{ row.supplier.trade_name }}</div>
        </template>
        <template #supplier_payment_method="{ row }">{{ row.supplier_payment_method?.name || '-' }}</template>
        <template #estimated="{ row }">{{ amountFormat(row.estimated) }} TSh</template>
        <template #real="{ row }">{{ amountFormat(row.real) }} TSh</template>
        <template #difference="{ row }">{{ amountFormat(row.difference) }} TSh</template>
      </v-client-table>
      <app-cells><h2 class="title">Completed</h2></app-cells>
      <v-client-table
        :data="table_completed.items"
        :columns="table_completed.columns"
        :options="table_completed.options"
        class="table-default"
        :class="{ 'table-default--loading': table_completed_preloader }"
      >
        <template #h__id>
          <div class="table-default__left">ID</div>
        </template>
        <template #h__supplier>
          <div class="table-default__left">Supplier</div>
        </template>
        <template #id="{ row }">
          <div class="table-default__left">
            <router-link :to="{name: 'storage-product-storage-orders-detail', params: {id: row.id }}"
                         class="table-default__link-border">
              Order - {{ row.id }}
            </router-link>
          </div>
        </template>
        <template #date="{ row }">
          {{ dateFormat(row.date) }}
        </template>
        <template #supplier="{ row }">
          <router-link
            v-if="is_general_manager || is_product_storage_manager || is_product_storage_supervisor"
            :to="{name: 'supplier-detail', params: {id: row.supplier.id }}"
            class="table-default__link-border"
          >
            {{ row.supplier.trade_name }}
          </router-link>
          <div v-else class="table-default__left">{{ row.supplier.trade_name }}</div>
        </template>
        <template #supplier_payment_method="{ row }">{{ row.supplier_payment_method?.name || '-' }}</template>
        <template #value="{ row }">{{ amountFormat(row.value) }} TSh</template>
      </v-client-table>
      <app-cells position="between">
        <div>
          <paginate
            :clickHandler="onClickPaginationCompleted"
            v-if="pagination_completed.pages > 1"
            v-model="pagination_completed.page"
            :page-count="pagination_completed.pages"
            :prev-text="'<'"
            :next-text="'>'"
            :container-class="'pagination'"
            :page-class="'pagination__item'"
            :page-link-class="'pagination__link'"
            :prev-class="'pagination__item pagination__item--prev'"
            :next-class="'pagination__item pagination__item--next'"
            :next-link-class="'pagination__link pagination__link--next'"
            :prev-link-class="'pagination__link pagination__link--prev'"
          />
        </div>
        <app-table-records :all="pagination_completed.count" :count="table_completed.items.length"
                           :page="pagination_completed.page"/>
      </app-cells>
    </template>
    <modal
      name="order_form"
      :width="400"
      :height="'auto'"
      :scrollable="true"
      :adaptive="true"
      :clickToClose="false"
      class="modal-not-overflow"
      draggable=".popup__title"
      :reset="true"
    >
      <div class="popup">
        <button @click="onCloseModal" class="popup__close" type="button"></button>
        <div class="popup__title">New order</div>
        <div class="popup__body">
          <form @submit.prevent="onCheckForm">
            <app-form-group v-if="!is_product_storage_storekeeper" label="Storekeeper" required>
              <app-select
                v-model="form.storekeeper"
                :options="employee_options"
                :reduce="item => item.id"
                :clearable="false"
                label="full_name"
                placeholder="Storekeeper"
                :error="$v.form.storekeeper.$error"
              />
              <template #error>
                <div v-if="$v.form.storekeeper.$dirty && !$v.form.storekeeper.required">Required field</div>
              </template>
            </app-form-group>
            <app-form-group label="Buyer" required>
              <app-select
                v-model="form.buyer"
                :options="buyer_options"
                :reduce="item => item.id"
                :clearable="false"
                label="full_name"
                placeholder="Buyer"
                :error="$v.form.buyer.$error"
              />
              <template #error>
                <div v-if="$v.form.buyer.$dirty && !$v.form.buyer.required">Required field</div>
              </template>
            </app-form-group>
            <app-form-group label="Supplier" required>
              <app-select
                @search="onSupplierSearch"
                v-model="form.supplier"
                :options="supplier_options"
                :clearable="false"
                label="trade_name"
                placeholder="Supplier"
                :error="$v.form.supplier.$error"
              />
              <template #error>
                <div v-if="$v.form.supplier.$dirty && !$v.form.supplier.required">Required field</div>
              </template>
            </app-form-group>
            <app-form-group label="Payment method" required v-if="form.supplier?.payment_methods.length > 0">
              <app-select
                v-model="form.supplier_payment_method"
                :options="form.supplier?.payment_methods"
                :reduce="item => item.id"
                :clearable="false"
                label="public_name"
                placeholder="Payment method"
                :error="$v.form.supplier_payment_method.$error"
              />
              <template #error>
                <div v-if="$v.form.supplier_payment_method.$dirty && !$v.form.supplier_payment_method.required">Required field</div>
              </template>
            </app-form-group>
            <div v-if="form.supplier && !form.supplier.payment_methods.length" class="popup__warning">
              Payment methods have not been verified for this supplier. Please reach out to the accounting
              department to complete the information. After that, you can create order.
            </div>
            <app-form-group label="Notes" label-for="notes">
              <app-textarea
                v-model="form.note"
                id="notes"
                placeholder="Notes"
              />
            </app-form-group>
            <app-cells position="center" :indent="false">
              <app-button :disabled="$v.form.$error" type="submit" ref="submit">Create order</app-button>
            </app-cells>
          </form>
        </div>
      </div>
    </modal>
  </div>
</template>

<script>
import {
  getEmployeesListSearch,
  getStorageProductStorageOrders,
  getStorageSuppliers,
  postStorageProductStorageOrders
} from '@/http'
import debounce from 'lodash/debounce'
import { required, requiredIf } from 'vuelidate/lib/validators'
import { format, parseISO } from 'date-fns'

export default {
  name: 'StorageProductStorageOrdersList',
  data() {
    return {
      page_loaded: false,
      filter_search: '',
      filter_item_id: '',
      filter_supplier: null,
      supplier_options: [],
      employee_options: [],
      buyer_options: [],
      form: {},
      table_draft: {
        items: [],
        columns: ['id', 'date', 'supplier', 'estimated'],
        options: {
          headings: {
            'id': 'ID',
            'date': 'Date',
            'supplier': 'Supplier',
            'estimated': 'Est. Value',
          },
          pagination: {show: false},
          sortable: [],
          perPage: 20,
          texts: {
            noResults: 'No matching entries',
          },
          rowClassCallback: () => 'table-default__row',
          resizableColumns: false
        },
      },
      table_ready: {
        items: [],
        columns: ['id', 'date', 'supplier', 'estimated'],
        options: {
          headings: {
            'id': 'ID',
            'date': 'Date',
            'supplier': 'Supplier',
            'estimated': 'Est. Value',
          },
          pagination: {show: false},
          sortable: [],
          perPage: 20,
          texts: {
            noResults: 'No matching entries',
          },
          rowClassCallback: () => 'table-default__row',
          resizableColumns: false
        },
      },
      table_process: {
        items: [],
        columns: ['id', 'date', 'supplier', 'supplier_payment_method', 'estimated', 'real', 'difference'],
        options: {
          headings: {
            'id': 'ID',
            'date': 'Date',
            'supplier': 'Supplier',
            'supplier_payment_method': 'Payment method',
            'estimated': 'Est. Value',
            'real': 'Real Value',
            'difference': 'Diff. Value',
          },
          pagination: {show: false},
          sortable: [],
          perPage: 20,
          texts: {
            noResults: 'No matching entries',
          },
          rowClassCallback: () => 'table-default__row',
          resizableColumns: false
        },
      },
      table_completed: {
        items: [],
        columns: ['id', 'date', 'supplier', 'supplier_payment_method', 'value'],
        options: {
          headings: {
            'id': 'ID',
            'date': 'Date',
            'supplier': 'Supplier',
            'supplier_payment_method': 'Payment method',
            'value': 'Value',
          },
          pagination: {show: false},
          sortable: [],
          perPage: 20,
          texts: {
            noResults: 'No matching entries',
          },
          rowClassCallback: () => 'table-default__row',
          resizableColumns: false
        },
      },
      pagination_completed: {
        pages: 1,
        page: 1,
        count: 1,
      },
      table_completed_preloader: true,
    }
  },
  validations: {
    form: {
      storekeeper: {
        required: requiredIf(function () {
          return !this.is_product_storage_storekeeper
        })
      },
      buyer: {required},
      supplier: {required},
      supplier_payment_method: {required},
    },
  },
  computed: {
    is_product_storage_storekeeper() {
      return this.$store.state.userGroups.some(group => group.code === 'product_storage_storekeeper')
    },
    is_product_storage_manager() {
      return this.$store.state.userGroups.some(group => group.code === 'product_storage_manager')
    },
    is_product_storage_supervisor() {
      return this.$store.state.userGroups.some(group => group.code === 'product_storage_supervisor')
    },
    is_general_manager() {
      return this.$store.state.userGroups.some(group => group.code === 'general_manager')
    }
  },
  created() {
    if (!this.is_product_storage_storekeeper) {
      getEmployeesListSearch({
        position: 'product_keeper',
        employment_status: 'working'
      })
        .then(response => {
          this.employee_options = response.data
          if (response.data.length) this.form.storekeeper = response.data[0].id
        })
    }
    Promise.all([
      getEmployeesListSearch({position: 'product_buyer', employment_status: 'working'}),
      this.fetchItemsDraft(),
      this.fetchItemsReady(),
      this.fetchItemsProcess(),
      this.fetchItemsCompleted()
    ])
      .then(response => {
        this.buyer_options = response[0].data
        if (response[0].data.length) this.form.buyer = response[0].data[0].id
        this.page_loaded = true
      })
  },
  methods: {
    async fetchItemsDraft() {
      const response = await getStorageProductStorageOrders({
        status: 'draft',
        search: this.filter_search,
        item: this.filter_search ? '' : this.filter_item_id,
        supplier: this.filter_supplier?.id,
      })
      this.table_draft.items = response.data
    },
    async fetchItemsReady() {
      const response = await getStorageProductStorageOrders({
        status: 'ready',
        search: this.filter_search,
        item: this.filter_search ? '' : this.filter_item_id,
        supplier: this.filter_supplier?.id,
      })
      this.table_ready.items = response.data
    },
    async fetchItemsProcess() {
      const response = await getStorageProductStorageOrders({
        status: 'in_process',
        search: this.filter_search,
        item: this.filter_search ? '' : this.filter_item_id,
        supplier: this.filter_supplier?.id,
      })
      this.table_process.items = response.data
    },
    async fetchItemsCompleted() {
      this.table_completed_preloader = true
      const response = await getStorageProductStorageOrders({
        status: 'completed',
        search: this.filter_search,
        item: this.filter_search ? '' : this.filter_item_id,
        supplier: this.filter_supplier?.id,
        page: this.pagination_completed.page,
        page_size: 20,
      })
      this.table_completed.items = response.data.results
      this.pagination_completed.pages = response.data.pages
      this.pagination_completed.count = response.data.count
      this.table_completed_preloader = false
    },
    onClickPaginationCompleted(page) {
      this.pagination_completed.page = page
      this.fetchItemsCompleted()
    },
    onShowModal() {
      this.$modal.show('order_form')
    },
    onCloseModal() {
      this.$modal.hide('order_form')
      this.form = {}
      this.$v.form.$reset()
    },
    onCheckForm() {
      this.$v.form.$touch()
      if (this.$v.form.$invalid) {
        this.$notify({
          type: 'info',
          title: 'Check that the form fields are filled in correctly',
        })
      } else {
        this.sendForm()
      }
    },
    sendForm() {
      this.$refs.submit.preload = true
      const data = {...this.form, supplier: this.form.supplier.id, section: 'products'}
      if (this.is_product_storage_storekeeper) data.storekeeper = this.$store.state.userData.employee.id
      postStorageProductStorageOrders(data)
        .then(response => {
          this.$notify({
            type: 'success',
            title: 'Order created',
          })
          this.$router.push({ name: 'storage-product-storage-orders-detail', params: { id: response.data.id } })
        })
        .catch(() => { this.$refs.submit.preload = false })
    },
    onFilterItems() {
      this.filter_search = ''
      this.filter_item_id = ''
      this.pagination_completed.page = 1
      this.fetchItemsDraft()
      this.fetchItemsProcess()
      this.fetchItemsCompleted()
    },
    amountFormat(amount) {
      return Intl.NumberFormat('ru-RU').format(amount)
    },
    dateFormat(date) {
      return date ? format(parseISO(date), 'dd MMM yyyy') : '-'
    },
    onSupplierSearch(search, loading) {
      loading(true)
      this.searchSupplier(loading, search, this)
    },
    searchSupplier: debounce((loading, search, vm) => {
      if (!search) {
        loading(false)
        vm.supplier_options = []
      } else {
        getStorageSuppliers({search}).then(response => {
          vm.supplier_options = response.data
          loading(false)
        })
      }
    }, 350),
    onOrdersSearch() {
      this.searchOrders(this)
    },
    searchOrders: debounce(vm => {
      vm.pagination_completed.page = 1
      vm.fetchItemsDraft()
      vm.fetchItemsProcess()
      vm.fetchItemsCompleted()
    }, 350),
  },
}
</script>